import { c } from "react/compiler-runtime";
import { useCache } from "@effektify/cache";
import { useState, useEffect } from "react";
import useLogger from "./useLogger.js";
import fetchData from "../api/fetchData.js";
import { isSubsequentReportDataResponse } from "../types/src/guards/data.js";
const useGetSubsequentData = (map, getToken) => {
  const $ = c(22);
  const logger = useLogger("useGetSubsequentData");
  const {
    addSimulatedData
  } = useCache();
  let t0;
  if ($[0] !== getToken) {
    t0 = fetchData(getToken);
    $[0] = getToken;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const fetcher = t0;
  const [isPending, setIsPending] = useState(false);
  const [completedFetches, setCompletedFetches] = useState(0);
  const [isWaiting, setIsWaiting] = useState(true);
  const [settledMap, setSettledMap] = useState(null);
  let t1;
  if ($[2] !== addSimulatedData || $[3] !== logger) {
    t1 = (error, keys) => {
      logger.error("Error fetching report data:", error);
      if (keys && keys.length >= 0) {
        keys.forEach(key => addSimulatedData(key, "error", null, "error"));
      }
    };
    $[2] = addSimulatedData;
    $[3] = logger;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const handleFetchError = t1;
  let t2;
  if ($[5] !== addSimulatedData || $[6] !== handleFetchError || $[7] !== logger) {
    t2 = (result, keys_0) => {
      if (result instanceof Error || result.status === "error") {
        handleFetchError(result, keys_0);
        return;
      }
      if (isSubsequentReportDataResponse(result)) {
        const {
          data
        } = result;
        Object.entries(data).forEach(t32 => {
          const [responseKey, dataset] = t32;
          if (keys_0.includes(responseKey)) {
            keys_0.forEach(key_0 => {
              logger.debug(`Adding data for key: ${key_0}`, {
                dataset
              });
              addSimulatedData(key_0, "success", dataset);
              setCompletedFetches(_temp);
            });
          }
        });
      }
    };
    $[5] = addSimulatedData;
    $[6] = handleFetchError;
    $[7] = logger;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const handleFetchResult = t2;
  let t3;
  let t4;
  if ($[9] !== addSimulatedData || $[10] !== fetcher || $[11] !== handleFetchError || $[12] !== handleFetchResult || $[13] !== logger || $[14] !== map) {
    t3 = () => {
      if (!map) {
        logger.debug("No map provided, skipping fetching data");
        return;
      }
      const fetchAll = async () => {
        setCompletedFetches(0);
        setIsPending(true);
        await Promise.all(Object.entries(map).map(async t52 => {
          const [, t6] = t52;
          const {
            keys: keys_1,
            endpoint
          } = t6;
          keys_1.forEach(key_1 => {
            addSimulatedData(key_1, "pending");
          });
          return fetcher({
            uri: endpoint.uri,
            method: endpoint.method
          }).then(result_0 => handleFetchResult(result_0, keys_1)).catch(err => handleFetchError(err, keys_1));
        })).catch(error_0 => handleFetchError(error_0, [])).finally(() => {
          setIsPending(false);
          setIsWaiting(false);
          setSettledMap(map);
        });
      };
      fetchAll();
    };
    t4 = [map, fetcher, addSimulatedData, logger, setIsPending, setIsWaiting, handleFetchError, handleFetchResult];
    $[9] = addSimulatedData;
    $[10] = fetcher;
    $[11] = handleFetchError;
    $[12] = handleFetchResult;
    $[13] = logger;
    $[14] = map;
    $[15] = t3;
    $[16] = t4;
  } else {
    t3 = $[15];
    t4 = $[16];
  }
  useEffect(t3, t4);
  let t5;
  if ($[17] !== completedFetches || $[18] !== isPending || $[19] !== isWaiting || $[20] !== settledMap) {
    t5 = {
      isPending,
      isWaiting,
      completedFetches,
      settledMap
    };
    $[17] = completedFetches;
    $[18] = isPending;
    $[19] = isWaiting;
    $[20] = settledMap;
    $[21] = t5;
  } else {
    t5 = $[21];
  }
  return t5;
};
function _temp(prev) {
  return prev + 1;
}
export { useGetSubsequentData as default };